<template>
  <div>
    <Connecting v-if="callState === 'connecting'" :licensePlate="licensePlate" :driver="driver" />
    <FailConnect
      v-if="callState === 'failConnect'"
      :licensePlate="licensePlate"
      :driver="driver"
      :vehicleId="vehicleId"
      @stopCall="stopCall"
      @tryAgain="startCall"
    />
    <OnGoing
      v-if="callState === 'onGoing'"
      :licensePlate="licensePlate"
      :driver="driver"
      :vehicleId="vehicleId"
      :muted="muted"
      :deviceType="deviceType"
      @stopCall="stopCall"
      @muteDevice="muteDevice"
      @unmuteDevice="unmuteDevice"
    />
  </div>
</template>

<script>
import Connecting from './CallItemState/Connecting.vue'
import FailConnect from './CallItemState/FailConnect.vue'
import OnGoing from './CallItemState/OnGoing.vue'
import Voip from './lib/voip'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  name: 'CallItem',
  components: {
    Connecting,
    FailConnect,
    OnGoing,
  },
  mixins: [MixPanel],
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      type: String,
      required: false,
      default: '',
    },
    callState: {
      type: String, // ENUM: onGoing, connecting, failConnect
      required: true,
    },
    vehicleId: {
      type: Number,
      required: true,
    },
    imei: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    muted: {
      type: Boolean,
      required: false,
      default: true,
    },
    deviceType: {
      type: String,
      required: true,
    },
    entryPoint: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      audio: null,
      isError: false,
      isClosed: false,
      isOpen: false,

      // state for vss
      recorderVss: null,
      audioPlayerVss: null,
    }
  },
  watch: {
    isError(isError) {
      if (isError) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'failConnect')
        this.$store.commit('voip/setVoipState', {
          vehicleId: this.vehicleId,
          values: { ...this.$store.state.voip.voipState[this.vehicleId], state: 'failConnect' },
        })
      }
    },
    isClosed(isClosed) {
      if (isClosed) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'failConnect')
        this.$store.commit('voip/setVoipState', {
          vehicleId: this.vehicleId,
          values: { ...this.$store.state.voip.voipState[this.vehicleId], state: 'failConnect' },
        })
      }
    },
    isOpen(isOpen) {
      if (isOpen) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'onGoing')
        this.$store.commit('voip/setVoipState', {
          vehicleId: this.vehicleId,
          values: { ...this.$store.state.voip.voipState[this.vehicleId], state: 'onGoing' },
        })
      }
    },
  },
  async mounted() {
    await this.startCall()
  },

  async beforeDestroy() {
    if (this.deviceType === 'bsj') {
      if (this.audio) {
        this.audio.stopCapture()
      }
    } else if (this.deviceType === 'vss-howen') {
      this.stopCallVssHowen()
    }
  },

  methods: {
    muteDevice() {
      this.track('VoIP Driver muted')
      this.$emit('setCallsValue', this.vehicleId, 'isMuted', true)
      this.audio.toggleMuteDevice(true)
      this.$forceUpdate()
    },
    unmuteDevice() {
      this.$emit('setCallsValue', this.vehicleId, 'isMuted', false)
      this.audio.toggleMuteDevice(false)
      this.$forceUpdate()
    },
    async startCall() {
      this.$emit('setCallsValue', this.vehicleId, 'state', 'connecting')
      if (this.deviceType === 'bsj') {
        this.audio = new Voip(this.token, this)
        await this.$nextTick()
        await this.audio.startCapture()
      } else if (this.deviceType === 'vss-howen') {
        // eslint-disable-next-line no-undef
        HWRecorder.get(
          async (rec) => {
            this.recorderVss = rec
            await this.$nextTick()
            this.recorderVss.start()
          },
          {
            sampleBits: 16,
            sampleRate: 8000,
          },
          this.callbackAudioPut
        )
      }
    },
    stopCall() {
      const mapEntryPoint = {
        modalDetailVehicle: 'Modal Detail Vehicle',
        floatingMap: 'Floating Map',
        alertCenter: 'Alert Center',
        detailNotification: 'Detail Notification',
        controlTower: 'Control Tower',
        mediaPlayerStreaming: 'Media Player Streaming',
      }
      if (mapEntryPoint?.[this.entryPoint]) {
        this.track(`${mapEntryPoint[this.entryPoint]} - VoIP End Call`, {
          entryPoint: `${mapEntryPoint[this.entryPoint]}`,
        })
      }
      this.track('VoIP End Call')
      if (this.deviceType === 'bsj') {
        this.audio.stopCapture()
      } else if (this.deviceType === 'vss-howen') {
        this.stopCallVssHowen()
      }
      this.$store.dispatch('voip/endCall', { vehicleId: this.vehicleId })
    },
    toggleMuteMic(isMuted) {
      if (this.audio) {
        this.audio.mediaStream.getAudioTracks().forEach((track) => {
          if (isMuted) {
            track.enabled = false
          } else {
            track.enabled = true
          }
        })
      }
    },
    async callbackAudioPut(arrayOfPcmData) {
      if (this.audioPlayerVss == null) {
        const wsUrl = process.env.VUE_APP_VSS_WS_URL
        const port = process.env.VUE_APP_VSS_PORT
        const serverIp = '52.220.96.82' // TODO : Put this to env
        const wsFullUrl = wsUrl + ':' + port + '/stream?ipaddr=' + serverIp

        const gUserName = ''
        const gFuncCode = ''

        var jsonRequest =
          '{"action":"3001","payload":{"sessionID":"20210306","deviceID":"' +
          this.imei +
          '","channel":"1","workMode":"1","username":"' +
          gUserName +
          '","bussType":"' +
          gFuncCode +
          '"}}'
        // eslint-disable-next-line no-undef
        this.audioPlayerVss = new HWMediaPlayer(wsFullUrl, jsonRequest)
        await this.$nextTick()
        this.audioPlayerVss.setSessionStateCallback(this.callbackSessionStateChangeVss)
        this.audioPlayerVss.play()
      }
      this.audioPlayerVss.putInAudioPcm(arrayOfPcmData, this.$store.state.voip.isMuted)
    },
    callbackSessionStateChangeVss(stateObj) {
      const audioPlayerStateIdle = 0
      const audioPlayerStatePlaying = 1
      const audioPlayerStatePausing = 2
      const audioPlayerStateCalling = 3
      const audioPlayerStateEnd = -1

      if (stateObj.state == audioPlayerStatePlaying) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'onGoing')
      } else if (stateObj.state == audioPlayerStateEnd) {
        this.stopCallVssHowen()
      } else if (stateObj.state == audioPlayerStateCalling) {
        this.$emit('setCallsValue', this.vehicleId, 'state', 'onGoing')
      }
    },

    stopCallVssHowen() {
      if (this.audioPlayerVss) {
        this.audioPlayerVss.stop()
        this.audioPlayerVss = null
      }
      if (this.recorderVss) this.recorderVss.stop()
    },
  },
}
</script>
